const APP_IDS = {
  Plants: 'plantasss',
  CVC: 'conocevaloraconserva',
};

export default APP_IDS;
